import {FC} from 'react';
import styled from 'styled-components';
import logo from './img/gem-logo.png';

const LogoImage = styled.img`
  width: 228px;
  height: 52px;
  object-fit: cover;
  object-position: left;

  @media (max-width: 768px) {
    width: 52px;
  }
`;

// TODO: See if we can get an SVG of this instead. Since it's a PNG we hard-code the dimensions here for faster rendering
export const Logo: FC = (props) => <LogoImage src={logo} alt="GEM Logo" {...props} />;
